import { Component } from '@angular/core';
import { googleAnalytics } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

  readonly gaTrackingId: string = googleAnalytics.trackingId;
  readonly gaUrlPrefix: string = googleAnalytics.urlPrefix;
  readonly gaIgnoreRoutes: string[] = googleAnalytics.ignoreRoutes;

}
